<template>
  <div>
    <p> <strong>Last updated:</strong> 04-16-2025</p>
    <p><strong>Prior version:</strong><nuxt-link :to="previousRoute" class=" text-primary-tint-1"> www.bambee.com/legal/previous-tos</nuxt-link></p>

    <GoogleDocsHTMLExportRenderer :copy="copy" />
  </div>
  </template>

<script>
  import { defineComponent } from '@nuxtjs/composition-api';
  import GoogleDocsHTMLExportRenderer from '@/modules/InformationPages/Legal/components/GoogleDocsHTMLExportRenderer.vue'
  import copy from './TOS.copy.ts'
  import useGlobalSettings from '@/hooks/useGlobalSettings';
  import {RouteBase, Slugs} from '@/modules/InformationPages/Legal/constants/Routes.ts'
  
  export default defineComponent({
    name: 'TOS',
    components: { GoogleDocsHTMLExportRenderer },
    setup() {
      const { setHeader } = useGlobalSettings();
  
      setHeader({
        header: 'Terms of Service',
        subheader: null,
        heroImage: null,
        metaTitle: `Terms of Service`,
        registration: false,
        noHero: false,
      });
      
      return {
        copy,
        previousRoute: `/${RouteBase}/${Slugs.TOS_PREVIOUS}`,
      }
    }
  });
  </script>

<style scoped>

  >>> .c7 {
      font-weight: 400;
      font-style: normal
  }

  >>> .c0 {
  }

  >>> .c5 {
      page-break-after: avoid;
  }

  >>> .c4 {
      page-break-after: avoid;
  }

  >>> .c1 {
      font-weight: 400;
      font-style: normal
  }

  >>> .c11 {
      font-style: normal
  }

  >>> .c10 {
      font-weight: 700
  }

  >>> .c2 {
      margin-left: 36pt
  }

</style>
